<template>
  <!-- Master the skills Five -->
  <section class="master-section-five">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-sm-12" data-aos="fade-down">
          <div class="section-five-sub">
            <div class="header-five-title mb-4">
              <h2>Master the skills to drive your career</h2>
            </div>
            <div class="career-five-content">
              <p data-aos="fade-down">
                Get certified, master modern tech skills, and level up your career —
                whether you’re starting out or a seasoned pro. 95% of eLearning learners
                report our hands-on earning learners report our hands-on
              </p>
            </div>
            <div class="d-flex align-items-center">
              <router-link to="/course/course-list" class="btn btn-primary me-2"
                >Join Course</router-link
              >
              <router-link to="/course/course-list" class="btn btn-secondary"
                >Learn More</router-link
              >
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="row align-items-center">
            <div class="col-lg-6 col-sm-6" data-aos="fade-down">
              <div class="skill-five-item">
                <div class="skill-five-icon bg-success">
                  <img src="@/assets/img/icon/skill-01.svg" alt="Stay motivated" />
                </div>
                <div class="skill-five-content">
                  <h3>Stay motivated with engaging instructors</h3>
                  <p>
                    eLearning learners report our hands-on content directly helped their
                    careers.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6" data-aos="fade-down">
              <div class="skill-five-item">
                <div class="skill-five-icon bg-skyblue">
                  <img src="@/assets/img/icon/skill-02.svg" alt="Stay motivated" />
                </div>
                <div class="skill-five-content">
                  <h3>Keep up with in the latest in cloud</h3>
                  <p>
                    eLearning learners report our hands-on content directly helped their
                    careers.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6" data-aos="fade-down">
              <div class="skill-five-item">
                <div class="skill-five-icon bg-danger">
                  <img src="@/assets/img/icon/skill-03.svg" alt="Stay motivated" />
                </div>
                <div class="skill-five-content">
                  <h3>Get certified with 100+ certification courses</h3>
                  <p>
                    eLearning learners report our hands-on content directly helped their
                    careers.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-sm-6" data-aos="fade-down">
              <div class="skill-five-item">
                <div class="skill-five-icon bg-info">
                  <img src="@/assets/img/icon/skill-04.svg" alt="Stay motivated" />
                </div>
                <div class="skill-five-content">
                  <h3>Build skills your way, from labs to courses</h3>
                  <p>
                    eLearning learners report our hands-on content directly helped their
                    careers.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Master the skills Five -->
</template>
